var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_879_25398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9951 0.90039C14.957 0.516113 14.7002 0.187988 14.3359 0.0581048C13.9756 -0.0703132 13.5654 0.018554 13.2929 0.292968L10.5859 3H5.41404L2.70701 0.292968C2.43357 0.0185541 2.02439 -0.0703131 1.66404 0.0581049C1.29978 0.187988 1.04294 0.516113 1.00486 0.90039L0.00485863 10.9004C-0.0215086 11.1631 0.057593 11.4258 0.223609 11.6304C0.357276 11.7946 3.28544 15.3372 6.99998 15.913V13.4141L4.58591 11H11.414L8.99998 13.4141V15.913C12.7145 15.3372 15.6427 11.7946 15.7763 11.6304C15.9424 11.4258 16.0215 11.1631 15.9951 10.9004L14.9951 0.90039ZM4.99998 9C4.44767 9 3.99998 8.55225 3.99998 8C3.99998 7.44769 4.44767 7 4.99998 7C5.55228 7 5.99998 7.44769 5.99998 8C5.99998 8.55225 5.55228 9 4.99998 9ZM11 9C10.4477 9 9.99998 8.55225 9.99998 8C9.99998 7.44769 10.4477 7 11 7C11.5523 7 12 7.44769 12 8C12 8.55225 11.5523 9 11 9Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_879_25398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.22030605.svg";
export { ForwardRef as ReactComponent };